"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_SPEAKING_ACTIVITY = void 0;
exports["default"] = startSpeakingActivity;
var START_SPEAKING_ACTIVITY = 'WEB_CHAT/START_SPEAKING';
exports.START_SPEAKING_ACTIVITY = START_SPEAKING_ACTIVITY;

function startSpeakingActivity() {
  return {
    type: START_SPEAKING_ACTIVITY
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTVEFSVF9TUEVBS0lOR19BQ1RJVklUWSIsInN0YXJ0U3BlYWtpbmdBY3Rpdml0eSIsInR5cGUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvYWN0aW9ucy9zdGFydFNwZWFraW5nQWN0aXZpdHkuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU1RBUlRfU1BFQUtJTkdfQUNUSVZJVFkgPSAnV0VCX0NIQVQvU1RBUlRfU1BFQUtJTkcnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBzdGFydFNwZWFraW5nQWN0aXZpdHkoKSB7XG4gIHJldHVybiB7XG4gICAgdHlwZTogU1RBUlRfU1BFQUtJTkdfQUNUSVZJVFlcbiAgfTtcbn1cblxuZXhwb3J0IHsgU1RBUlRfU1BFQUtJTkdfQUNUSVZJVFkgfTtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBLElBQU1BLHVCQUF1QixHQUFHLHlCQUFoQzs7O0FBRWUsU0FBU0MscUJBQVQsR0FBaUM7RUFDOUMsT0FBTztJQUNMQyxJQUFJLEVBQUVGO0VBREQsQ0FBUDtBQUdEIn0=